module.exports = __webpack_public_path__ + "img/btkPay.e3578962.png";